/**
 * Comprehensive Pokemon name database for game detection.
 * Includes Pokemon names, trainer names, set names, and product keywords.
 */

// All Pokemon names (Gen 1-9, ~1000+ Pokemon)
// Sorted by popularity/value for efficient early matching
export const POKEMON_NAMES = [
  // Most valuable/popular (check first)
  'pikachu', 'charizard', 'mewtwo', 'mew', 'lugia', 'ho-oh',
  'rayquaza', 'umbreon', 'espeon', 'gengar', 'dragonite', 'gyarados',
  'blastoise', 'venusaur', 'alakazam', 'machamp', 'snorlax', 'lapras',
  'eevee', 'vaporeon', 'jolteon', 'flareon', 'leafeon', 'glaceon', 'sylveon',
  'arceus', 'dialga', 'palkia', 'giratina', 'darkrai', 'shaymin', 'celebi',
  'jirachi', 'deoxys', 'latios', 'latias', 'groudon', 'kyogre',
  
  // Gen 1 (Kanto)
  'bulbasaur', 'ivysaur', 'charmander', 'charmeleon', 'squirtle', 'wartortle',
  'caterpie', 'metapod', 'butterfree', 'weedle', 'kakuna', 'beedrill',
  'pidgey', 'pidgeotto', 'pidgeot', 'rattata', 'raticate', 'spearow', 'fearow',
  'ekans', 'arbok', 'sandshrew', 'sandslash', 'nidoran', 'nidorina', 'nidoqueen',
  'nidorino', 'nidoking', 'clefairy', 'clefable', 'vulpix', 'ninetales',
  'jigglypuff', 'wigglytuff', 'zubat', 'golbat', 'oddish', 'gloom', 'vileplume',
  'paras', 'parasect', 'venonat', 'venomoth', 'diglett', 'dugtrio', 'meowth', 'persian',
  'psyduck', 'golduck', 'mankey', 'primeape', 'growlithe', 'arcanine',
  'poliwag', 'poliwhirl', 'poliwrath', 'abra', 'kadabra', 'bellsprout', 'weepinbell',
  'victreebel', 'tentacool', 'tentacruel', 'geodude', 'graveler', 'golem',
  'ponyta', 'rapidash', 'slowpoke', 'slowbro', 'magnemite', 'magneton',
  'farfetchd', "farfetch'd", 'doduo', 'dodrio', 'seel', 'dewgong', 'grimer', 'muk',
  'shellder', 'cloyster', 'gastly', 'haunter', 'onix', 'drowzee', 'hypno',
  'krabby', 'kingler', 'voltorb', 'electrode', 'exeggcute', 'exeggutor',
  'cubone', 'marowak', 'hitmonlee', 'hitmonchan', 'lickitung', 'koffing', 'weezing',
  'rhyhorn', 'rhydon', 'chansey', 'tangela', 'kangaskhan', 'horsea', 'seadra',
  'goldeen', 'seaking', 'staryu', 'starmie', 'mr. mime', 'mr mime', 'scyther',
  'jynx', 'electabuzz', 'magmar', 'pinsir', 'tauros', 'magikarp', 'ditto',
  'porygon', 'omanyte', 'omastar', 'kabuto', 'kabutops', 'aerodactyl',
  'articuno', 'zapdos', 'moltres', 'dratini', 'dragonair',
  
  // Gen 2 (Johto)
  'chikorita', 'bayleef', 'meganium', 'cyndaquil', 'quilava', 'typhlosion',
  'totodile', 'croconaw', 'feraligatr', 'sentret', 'furret', 'hoothoot', 'noctowl',
  'ledyba', 'ledian', 'spinarak', 'ariados', 'crobat', 'chinchou', 'lanturn',
  'pichu', 'cleffa', 'igglybuff', 'togepi', 'togetic', 'natu', 'xatu',
  'mareep', 'flaaffy', 'ampharos', 'bellossom', 'marill', 'azumarill',
  'sudowoodo', 'politoed', 'hoppip', 'skiploom', 'jumpluff', 'aipom',
  'sunkern', 'sunflora', 'yanma', 'wooper', 'quagsire', 'murkrow', 'misdreavus',
  'unown', 'wobbuffet', 'girafarig', 'pineco', 'forretress', 'dunsparce',
  'gligar', 'steelix', 'snubbull', 'granbull', 'qwilfish', 'scizor', 'shuckle',
  'heracross', 'sneasel', 'teddiursa', 'ursaring', 'slugma', 'magcargo',
  'swinub', 'piloswine', 'corsola', 'remoraid', 'octillery', 'delibird',
  'mantine', 'skarmory', 'houndour', 'houndoom', 'kingdra', 'phanpy', 'donphan',
  'porygon2', 'stantler', 'smeargle', 'tyrogue', 'hitmontop', 'smoochum',
  'elekid', 'magby', 'miltank', 'blissey', 'raikou', 'entei', 'suicune',
  'larvitar', 'pupitar', 'tyranitar',
  
  // Gen 3 (Hoenn)
  'treecko', 'grovyle', 'sceptile', 'torchic', 'combusken', 'blaziken',
  'mudkip', 'marshtomp', 'swampert', 'poochyena', 'mightyena', 'zigzagoon', 'linoone',
  'wurmple', 'silcoon', 'beautifly', 'cascoon', 'dustox', 'lotad', 'lombre', 'ludicolo',
  'seedot', 'nuzleaf', 'shiftry', 'taillow', 'swellow', 'wingull', 'pelipper',
  'ralts', 'kirlia', 'gardevoir', 'surskit', 'masquerain', 'shroomish', 'breloom',
  'slakoth', 'vigoroth', 'slaking', 'nincada', 'ninjask', 'shedinja',
  'whismur', 'loudred', 'exploud', 'makuhita', 'hariyama', 'azurill', 'nosepass',
  'skitty', 'delcatty', 'sableye', 'mawile', 'aron', 'lairon', 'aggron',
  'meditite', 'medicham', 'electrike', 'manectric', 'plusle', 'minun',
  'volbeat', 'illumise', 'roselia', 'gulpin', 'swalot', 'carvanha', 'sharpedo',
  'wailmer', 'wailord', 'numel', 'camerupt', 'torkoal', 'spoink', 'grumpig',
  'spinda', 'trapinch', 'vibrava', 'flygon', 'cacnea', 'cacturne', 'swablu', 'altaria',
  'zangoose', 'seviper', 'lunatone', 'solrock', 'barboach', 'whiscash',
  'corphish', 'crawdaunt', 'baltoy', 'claydol', 'lileep', 'cradily', 'anorith', 'armaldo',
  'feebas', 'milotic', 'castform', 'kecleon', 'shuppet', 'banette', 'duskull', 'dusclops',
  'tropius', 'chimecho', 'absol', 'wynaut', 'snorunt', 'glalie', 'spheal', 'sealeo', 'walrein',
  'clamperl', 'huntail', 'gorebyss', 'relicanth', 'luvdisc', 'bagon', 'shelgon', 'salamence',
  'beldum', 'metang', 'metagross', 'regirock', 'regice', 'registeel',
  'kyogre', 'groudon', 'rayquaza', 'jirachi', 'deoxys',
  
  // Gen 4-9 popular Pokemon
  'lucario', 'garchomp', 'togekiss', 'roserade', 'weavile', 'magnezone',
  'rhyperior', 'electivire', 'magmortar', 'leafeon', 'glaceon', 'gliscor',
  'mamoswine', 'gallade', 'dusknoir', 'froslass', 'rotom', 'uxie', 'mesprit', 'azelf',
  'heatran', 'regigigas', 'cresselia', 'phione', 'manaphy', 'darkrai', 'shaymin',
  'victini', 'snivy', 'tepig', 'oshawott', 'zorua', 'zoroark', 'hydreigon',
  'volcarona', 'reshiram', 'zekrom', 'kyurem', 'keldeo', 'meloetta', 'genesect',
  'chespin', 'fennekin', 'froakie', 'greninja', 'talonflame', 'sylveon',
  'aegislash', 'hawlucha', 'noivern', 'xerneas', 'yveltal', 'zygarde', 'diancie', 'hoopa', 'volcanion',
  'rowlet', 'litten', 'popplio', 'decidueye', 'incineroar', 'primarina',
  'lycanroc', 'mimikyu', 'golisopod', 'silvally', 'toxapex', 'kommo-o',
  'tapu koko', 'tapu lele', 'tapu bulu', 'tapu fini', 'cosmog', 'cosmoem',
  'solgaleo', 'lunala', 'nihilego', 'buzzwole', 'pheromosa', 'xurkitree',
  'celesteela', 'kartana', 'guzzlord', 'necrozma', 'magearna', 'marshadow',
  'poipole', 'naganadel', 'stakataka', 'blacephalon', 'zeraora', 'meltan', 'melmetal',
  'grookey', 'scorbunny', 'sobble', 'rillaboom', 'cinderace', 'inteleon',
  'corviknight', 'dracovish', 'dragapult', 'toxtricity', 'grimmsnarl', 'alcremie',
  'eternatus', 'zacian', 'zamazenta', 'kubfu', 'urshifu', 'zarude', 'regieleki', 'regidrago',
  'glastrier', 'spectrier', 'calyrex',
  'sprigatito', 'fuecoco', 'quaxly', 'meowscarada', 'skeledirge', 'quaquaval',
  'koraidon', 'miraidon', 'walking wake', 'iron leaves', 'ogerpon', 'terapagos',
  'pecharunt', 'iron boulder', 'iron crown', 'gouging fire', 'raging bolt',
  
  // Common misspellings and alternate forms
  'zard', 'pika', 'mewtoo', 'raquaza', 'arcius',
] as const;

// Pokemon trainer and character names
export const POKEMON_TRAINER_NAMES = [
  // Gym Leaders & Elite Four
  'lt. surge', 'lt surge', 'brock', 'misty', 'erika', 'koga', 'sabrina',
  'blaine', 'giovanni', 'lorelei', 'bruno', 'agatha', 'lance',
  'falkner', 'bugsy', 'whitney', 'morty', 'chuck', 'jasmine', 'pryce', 'clair',
  'will', 'karen',
  'roxanne', 'brawly', 'wattson', 'flannery', 'norman', 'winona', 'tate', 'liza',
  'wallace', 'steven', 'sidney', 'phoebe', 'glacia', 'drake',
  'roark', 'gardenia', 'maylene', 'crasher wake', 'fantina', 'byron', 'candice', 'volkner',
  'aaron', 'bertha', 'flint', 'lucian', 'cynthia',
  'chili', 'cress', 'cilan', 'lenora', 'burgh', 'elesa', 'clay', 'skyla',
  'brycen', 'drayden', 'iris', 'shauntal', 'marshal', 'grimsley', 'caitlin', 'alder',
  'viola', 'grant', 'korrina', 'ramos', 'clemont', 'valerie', 'olympia', 'wulfric',
  'malva', 'siebold', 'wikstrom', 'drasna', 'diantha',
  'ilima', 'lana', 'kiawe', 'mallow', 'sophocles', 'acerola', 'mina',
  'hala', 'olivia', 'nanu', 'hapu', 'molayne', 'kahili', 'kukui',
  'milo', 'nessa', 'kabu', 'bea', 'allister', 'opal', 'gordie', 'melony',
  'piers', 'raihan', 'marnie', 'leon', 'hop', 'bede',
  'grusha', 'brassius', 'iono', 'kofu', 'larry', 'ryme', 'tulip', 'grusha',
  'rika', 'poppy', 'hassel', 'geeta', 'nemona', 'arven', 'penny', 'giacomo',
  
  // Anime & Game protagonists
  'ash', 'ash ketchum', 'red', 'blue', 'green', 'leaf', 'gold', 'silver', 'crystal',
  'ethan', 'lyra', 'brendan', 'may', 'lucas', 'dawn', 'barry',
  'hilbert', 'hilda', 'nate', 'rosa', 'calem', 'serena',
  'elio', 'selene', 'victor', 'gloria', 'florian', 'juliana',
  
  // Team leaders
  'team rocket', 'team magma', 'team aqua', 'team galactic', 'team plasma',
  'team flare', 'team skull', 'team yell', 'team star',
  'jessie', 'james', 'meowth', 'butch', 'cassidy',
  'maxie', 'archie', 'cyrus', 'ghetsis', 'lysandre', 'guzma', 'lusamine',
  
  // Professors
  'professor oak', 'professor elm', 'professor birch', 'professor rowan',
  'professor juniper', 'professor sycamore', 'professor kukui',
  'professor magnolia', 'professor sonia', 'professor sada', 'professor turo',
] as const;

// All Pokemon set names across all eras
export const POKEMON_SET_NAMES = [
  // Base Era (WOTC)
  'base set', 'base set 2', 'jungle', 'fossil', 'team rocket',
  'gym heroes', 'gym challenge', 'legendary collection',
  
  // Neo Era
  'neo genesis', 'neo discovery', 'neo revelation', 'neo destiny',
  
  // e-Card Era
  'expedition', 'aquapolis', 'skyridge',
  
  // EX Era
  'ruby sapphire', 'sandstorm', 'dragon', 'team magma vs team aqua',
  'hidden legends', 'firered leafgreen', 'team rocket returns',
  'deoxys', 'emerald', 'unseen forces', 'delta species',
  'legend maker', 'holon phantoms', 'crystal guardians',
  'dragon frontiers', 'power keepers',
  
  // Diamond & Pearl Era
  'diamond pearl', 'mysterious treasures', 'secret wonders', 'great encounters',
  'majestic dawn', 'legends awakened', 'stormfront', 'platinum',
  'rising rivals', 'supreme victors', 'arceus',
  
  // HeartGold SoulSilver Era
  'heartgold soulsilver', 'unleashed', 'undaunted', 'triumphant',
  'call of legends',
  
  // Black & White Era
  'black white', 'emerging powers', 'noble victories', 'next destinies',
  'dark explorers', 'dragons exalted', 'dragon vault', 'boundaries crossed',
  'plasma storm', 'plasma freeze', 'plasma blast', 'legendary treasures',
  
  // XY Era
  'kalos starter set', 'xy base', 'flashfire', 'furious fists',
  'phantom forces', 'primal clash', 'roaring skies', 'ancient origins',
  'breakthrough', 'breakpoint', 'fates collide', 'steam siege',
  'evolutions', 'generations',
  
  // Sun & Moon Era
  'sun moon', 'guardians rising', 'burning shadows', 'shining legends',
  'crimson invasion', 'ultra prism', 'forbidden light', 'celestial storm',
  'dragon majesty', 'lost thunder', 'team up', 'detective pikachu',
  'unbroken bonds', 'unified minds', 'hidden fates', 'cosmic eclipse',
  
  // Sword & Shield Era
  'sword shield', 'rebel clash', 'darkness ablaze', 'champions path',
  'vivid voltage', 'shining fates', 'battle styles', 'chilling reign',
  'evolving skies', 'celebrations', 'fusion strike', 'brilliant stars',
  'astral radiance', 'pokemon go', 'lost origin', 'silver tempest',
  'crown zenith',
  
  // Scarlet & Violet Era
  'scarlet violet', 'paldea evolved', 'obsidian flames', 'pokemon 151',
  '151', 'paradox rift', 'paldean fates', 'temporal forces',
  'twilight masquerade', 'shrouded fable', 'stellar crown',
  'surging sparks', 'prismatic evolutions', 'journey together',
  'destined rivals', 'black bolt', 'white flare',
  
  // Mega / 2025-2026 sets
  'mega evolution', 'mega latias', 'mega lucario', 'ascended heroes',
  'phantasmal flames', 'battle deck',
  
  // Japanese-specific sets
  'shiny treasure', 'shiny treasure ex', 'mask of change', 'night wanderer',
  'wild force', 'cyber judge', 'terastal fest', 'terastal fest ex',
  'battle partners', 'heat wave arena',
  'super electric breaker', 'transformation mask', 'crimson haze',
  'raging surf', 'ancient roar', 'future flash', 'clay burst', 'snow hazard',
  'violet ex', 'scarlet ex', 'triplet beat', 'vstar universe',
  
  // Special sets
  '25th anniversary', 'celebrations', 'legendary collection', 'premium collection',
  'special collection', 'ultra premium collection', 'gold box', 'gift box',
] as const;


// Pokemon product keywords
export const POKEMON_PRODUCT_KEYWORDS = [
  // Product types
  'elite trainer box', 'etb', 'booster bundle', 'ultra premium collection',
  'premium collection', 'special collection', 'trainer box',
  'build battle', 'build & battle', 'prerelease kit',
  'blister pack', 'sleeved booster', 'mini tin', 'collector chest',
  'pokeball tin', 'poke ball tin', 'poke ball', 'pokéball',
  'collection box', 'pin collection', 'figure collection',
  
  // Card types
  'trainer gallery', 'radiant collection', 'gold star',
  'vmax', 'vstar', 'v-union', 'tag team', 'gx', 'ex ', ' ex',
  'illustration rare', 'special art rare', 'full art', 'rainbow rare',
  'hyper rare', 'secret rare', 'amazing rare', 'shiny rare',
  'tera ex', 'terastal', 'paradox',
  
  // Regions/Themes
  'kanto', 'johto', 'hoenn', 'sinnoh', 'unova', 'kalos', 'alola', 'galar', 'paldea',
] as const;
